import SchoolList from './SchoolList';

export default SchoolList;
